/** Shared panel chrome for Help page sections (PDF + manual guide). */
export const HELP_PANEL_SX = {
    p: {xs: 1.5, md: 2},
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 2,
    overflow: 'hidden',
};

export const HELP_PAGE_SX = {
    bgcolor: 'grey.50',
    minHeight: '100%',
    py: {xs: 1.5, md: 2},
};

export const HELP_CONTAINER_SX = {
    px: {xs: 2, sm: 2.5, md: 3},
};

export const HELP_STACK_SPACING = 2;
